



















import Vue from "vue";
import { LetterOfCreditStore } from "./letterOfCreditApi";
import IconButton from "@/components/IconButton.vue";
import { dateFormatHU } from "@/filters/date-format";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import { LetterOfCreditDto } from "./letterOfCredit";
import { t } from "@/plugins/i18n";

export default Vue.extend({
  filters: { dateFormatHU },
  components: { IconButton, ApiSearchPage },
  data() {
    return {
      store: new LetterOfCreditStore(),
    };
  },
  async beforeMount() {
    await this.store.set();
  },
  methods: {
    create() {
      this.$router.push(`/letters-of-credit/0`);
    },
    openEditor(item: LetterOfCreditDto) {
      this.$router.push(`/letters-of-credit/${item.id}`);
    },
    getDate(date: Date | null | undefined): string {
      if (typeof date != "undefined" && date != null) {
        return dateFormatHU(date.toString());
      } else {
        return "";
      }
    },
  },
  computed: {
    columns: (): ApiSearchColumn[] => [
      {
        title: t("Id"),
        field: "id",
      },
      {
        title: t("Partner"),
        field: "partnerName",
      },
      {
        title: t("BankNeve"),
        field: "bankName",
      },
      {
        title: t("Osszeg"),
        field: "amount",
        type: ColumnType.Money,
      },
      {
        title: t("Koltseg"),
        field: "cost",
        type: ColumnType.Money,
      },
      {
        title: t("Valuta"),
        field: "currency",
      },
      {
        title: t("LetterOfCredit_UzletiFolyamat"),
        field: "businessProcessName",
      },
      {
        title: t("LetterOfCredit_Benyujthatosag"),
        field: "submitEventName",
      },
      {
        title: t("LetterOfCredit_DokumentumKovetelmenyek"),
        field: "submitRequirementName",
      },
      {
        title: t("LetterOfCredit_DokumentumokBenyujtva"),
        field: "requirementOkDate",
        type: ColumnType.Date,
      },
      {
        title: t("FizetesiHatarido"),
        field: "payTerm",
        type: ColumnType.Date,
      },
      {
        title: t("Statusz"),
        field: "statusName",
      },
      { cell: "command", filterable: false, sortable: false },
    ],
  },
});
